export default __webpack_public_path__ + "static/media/forbidden-banner.3fd31c7b.svg";